import { Text } from '#app/components/Primitives/Text.js';
import { css, styled } from 'styled-components';

export const Card = styled.div`
  ${({ theme }) => css`
    display: grid;
    grid-template-columns: auto 1fr;
    grid-template-rows: min-content;
    grid-template-areas: 'button title' 'description description' 'links links';
    grid-gap: 4px 12px;
    width: 100%;
    padding: 16px;
    margin-left: auto;
    margin-right: auto;
    background-color: ${theme.colorsV2.gray05};
    border-radius: 20px;

    ${theme.mediaQueries.xl} {
      grid-template-areas: 'button title' 'button description' 'button links';
      grid-gap: 4px 24px;
      padding: 24px;
    }
  `}
`;

export const CreateButton = styled.button`
  ${({ theme }) => css`
    width: 40px;
    height: 40px;
    font-size: 16px;
    line-height: 1;
    color: ${theme.colorsV2.gray80};
    background: ${theme.colorsV2.white};
    border: 1px solid ${theme.colorsV2.gray80};
    transition: background 0.2s ease-in-out;
    border-radius: 50%;

    &:hover {
      background: ${theme.colorsV2.gray10};
    }

    ${theme.mediaQueries.xl} {
      width: 48px;
      height: 48px;
      margin-top: 2px;
      grid-area: button;
      font-size: 32px;
    }

    & > div {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
  `}
`;

export const TitleArea = styled.div`
  grid-area: title;
  align-self: center;
`;

export const Title = styled(Text)`
  ${({ theme }) => css`
    margin: 0;
    border: 0px;
    color: ${theme.colorsV2.black};
  `}
`;

export const Description = styled(Text)`
  ${({ theme }) => css`
    grid-area: description;
    color: ${theme.colorsV2.gray60};
    font-size: 16px;
    && {
      font-weight: 400;
    }
  `}
`;

export const Links = styled.ul`
  ${({ theme }) => css`
    grid-area: links;
    position: relative;
    color: ${theme.colorsV2.gray80};
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    letter-spacing: -0.15px;
    list-style: inside;
    margin-top: 24px;
    display: flex;
    flex-flow: column nowrap;
    gap: 16px;

    & > li {
      display: flex;
      flex-flow: row nowrap;
      gap: 6px;
      align-items: center;
      &:first-child {
        margin-top: 0;
      }
    }

    & img {
      width: 16px;
      height: 16px;
    }

    ${theme.mediaQueries.md} {
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      list-style: none;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: unset;

      & > li {
        position: relative;

        border-bottom: 1px solid transparent;

        &::before {
          position: absolute;
          top: 0;
          left: -8px;
          bottom: 0;
          height: 16px;
          width: 1px;
          display: block;
          content: '';
          background-color: #e5e7eb;
        }

        &:first-child {
          margin-left: 0;

          &::before {
            display: none;
          }
        }

        &:hover {
          border-bottom: 1px solid ${theme.colorsV2.gray80};
        }
      }
    }
  `}
`;

export const NativeEmoji = styled.span`
  font-size: 16px;
`;
